import { getPageData } from '@/utils/getPageData';
import { QueryKey } from '@tanstack/react-query';
import { useGetDeptsSuspenseInfinite } from 'ap-openapi';
import { useEffect, useMemo } from 'react';

export const useGetDeptsAllSuspense = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetDeptsSuspenseInfinite(
      {
        per: 1000,
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return Number(url.searchParams.get('page'));
          },
        },
      }
    );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  return useMemo(() => getPageData(data, 'depts'), [data]);
};

type UseGetDeptsWithAgentApplicantResourceOptions = {
  queryKey?: QueryKey;
};

export const useGetDeptsWithAgentApplicantResource = (
  options?: UseGetDeptsWithAgentApplicantResourceOptions
) => {
  const { queryKey } = options || {};
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
  } = useGetDeptsSuspenseInfinite(
    {
      per: 1000,
    },
    {
      query: {
        getNextPageParam: (page) => {
          const url = new URL(page.data.next ?? '/', location.href);
          if (!url.searchParams.has('page')) return undefined;
          return Number(url.searchParams.get('page'));
        },
        queryKey,
      },
      request: {
        headers: {
          agentApplicantResource: 'dept',
        },
      },
    }
  );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  const items = useMemo(() => getPageData(data, 'depts'), [data]);

  return {
    items,
    isLoading: isFetching || isFetchingNextPage || hasNextPage,
  };
};
